// **************************************************
// Help Links toggle
// **************************************************

attachEvent('.help-links__item-title--nohref', 'click', (ev) => {
  const helpLinkItem = ev.target.closest('.help-links__item');
  const helpLinkContent = helpLinkItem.querySelector('.help-links__item-content');
  helpLinkItem.classList.toggle('is-open');
  slideToggle(helpLinkContent, 300, 'block');
});
